import dynaForms from '@elab/core/utils/dynaForms';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';
import * as addressRelations from '@elab/core/utils/addressRelations';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as addressRelationsInitialState } from '@elab/core/utils/addressRelations/reducers';

import getTypes from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    ...addressRelationsInitialState(state),
    ...initialData,
    shouldPrefill: true,
    shouldSkipPhonePrefill: false,
});

const createReducer = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const addressSuggestionsReduce = addressRelations.createReducer(storeName);
    const types = getTypes(storeName);

    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);
        state = addressSuggestionsReduce(state, action);
        switch (action.type) {
            case types.AFTER_INITIALIZE:
                return dynaForms.afterInitializeReduce(state);

            case types.INITIALIZE_DATA_FIELD_VALUE:
                return {
                    ...state,
                    ...(action.payload.name === 'dateOfBirth' && {
                        savedDateOfBirthValue: action.payload.value,
                    }),
                    data: {
                        ...state.data,
                        [action.payload.name]: {
                            ...state.data[action.payload.name],
                            value: action.payload.value,
                        },
                    },
                };
            case types.SET_FAKE_VALIDATION: {
                const { name, validations = {} } = action.payload;
                return {
                    ...state,
                    data: {
                        ...state.data,
                        [name]: {
                            ...state.data[name],
                            required: validations.required,
                            value: validations.value,
                            constraints: validations.constraints,
                            initialConstraints: validations.constraints,
                        },
                    },
                };
            }
            case types.SHOULD_PREFILL_FORM:
                return reduceAction(state, 'shouldPrefill', action.payload);

            case types.SHOULD_PREFILL_PHONE:
                return reduceAction(state, 'shouldSkipPhonePrefill', action.payload);

            case types.PRESERVE_PHONE_NUMBER_PATTERN: {
                return reduceAction(state, 'preservePhoneNumberPattern', action.payload);
            }
            default:
                return state;
        }
    };
};

export default createReducer;
